import { render, staticRenderFns } from "./BackendDownloadOverview.vue?vue&type=template&id=4cac1c39&lang=pug"
import script from "./BackendDownloadOverview.vue?vue&type=script&lang=js"
export * from "./BackendDownloadOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports